// extracted by mini-css-extract-plugin
export default {"codeFormContainer":"CodeForm_codeFormContainer__ooc4T","codeInput":"CodeForm_codeInput__kOKO5","button":"CodeForm_button__ZegzK","resendCodeText":"CodeForm_resendCodeText__W3iMv"};